import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/admin/content/assets/:id/views
//
// Phase 7 sub-bucket 13. Backs the asset detail page's Views tab. The shape
// is enhanced over the legacy /views page (total + uniquePartners +
// 30-day buckets + recent 50) so the new tab can render hero cards + a
// sparkline + the recent feed in one fetch. The aggregation runs in the
// worker — see services/content.ts::loadAssetViewAnalytics.
//
// No mutation hook invalidates this key today; the analytics roll-up is
// best-effort and refreshes on tab visit (default 5-min staleTime is
// fine). Future: `logAssetView` from the portal could optimistically
// patch `total`, but that's a separate workstream.
export type AssetViewAnalyticsResponse = {
  total: number;
  uniquePartners: number;
  timeseries30d: Array<{ date: string; count: number }>;
  recent: Array<{
    id: string;
    viewed_at: string;
    partner: { id: string; company_name: string } | null;
    user: { id: string; full_name: string | null } | null;
  }>;
};

export function useAssetViews(id: string | undefined) {
  return useQuery<AssetViewAnalyticsResponse, ApiClientError>({
    queryKey: id ? queryKeys.content.views(id) : ["content", "detail", "__missing__", "views"],
    queryFn: () =>
      apiFetch<AssetViewAnalyticsResponse>(`/admin/content/assets/${id}/views`),
    enabled: !!id,
  });
}
